"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaysteReceivableSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
const invoice_status_computed_mapping_1 = require("../base/invoice-status-computed-mapping");
const meta_data_invoice_1 = require("../base/meta-data-invoice");
const AllServiceStatuses = [
    ...new Set([
        ...transport_types_1.Commercial.Enums.CommercialSubscriptionStatuses,
        ...transport_types_1.Operations.Enums.OperationsSubscriptionStatuses,
        ...transport_types_1.Order.OrderStatuses,
    ]),
];
const WaysteCommercialSubscriptionStatusLabels = Object.fromEntries(Object.entries(transport_types_1.Commercial.Enums.CommercialSubscriptionStatusLabels).map(([key, value]) => [key, value.wayste]));
const OperationsSubscriptionStatusLabels = Object.fromEntries(Object.entries(transport_types_1.Operations.Enums.OperationsSubscriptionStatusLabels).map(([key, value]) => [key, value.wayste]));
const AllServiceStatusLabels = {
    ...transport_types_1.Order.SourgumOrderStatusLabels,
    ...WaysteCommercialSubscriptionStatusLabels,
    ...OperationsSubscriptionStatusLabels,
};
exports.WaysteReceivableSchema = {
    name: 'wayste-receivable',
    alias: 'Wayste Receivable',
    shortName: 'Invoice',
    applications: ['wayste'],
    returnType: {
        wayste: transport_types_1.Invoice.WaysteReceivableTransport,
    },
    searchableAttributes: [
        {
            field: 'customerName',
            alias: 'Customer Name',
            shortName: 'Name',
            searchableByDefault: true,
        },
        {
            field: 'customerCompanyName',
            alias: 'Company',
            shortName: 'Company',
            searchableByDefault: true,
        },
        {
            field: 'customerAccountNumber',
            alias: 'Account Number',
            shortName: 'Account Number',
            searchableByDefault: false,
        },
        {
            field: 'invoiceDetails.orderNumber',
            alias: 'Order Number',
            shortName: 'orderNumber',
            searchableByDefault: false,
        },
        {
            field: 'invoiceDetails.invoiceNumber',
            alias: 'Invoice Number',
            shortName: 'invoiceNumber',
            searchableByDefault: true,
        },
        {
            field: 'invoiceDetails.memo',
            alias: 'Memo',
            shortName: 'memo',
            searchableByDefault: true,
        },
        {
            field: 'invoiceDetails.lineItems.references.entityData.refServiceLocation.address.addressLine1',
            alias: 'Address',
            shortName: 'Address',
            searchableByDefault: true,
        },
        {
            field: 'invoiceDetails.lineItems.references.entityData.refServiceLocation.address.addressLine2',
            alias: 'Service Location Address 2',
            searchableByDefault: false,
        },
        {
            field: 'invoiceDetails.lineItems.references.entityData.refServiceLocation.address.state',
            alias: 'Service Location State',
            shortName: 'State',
            searchableByDefault: false,
        },
        {
            field: 'invoiceDetails.lineItems.references.entityData.refServiceLocation.address.city',
            alias: 'Service Location City',
            shortName: 'City',
            searchableByDefault: true,
        },
        {
            field: 'invoiceDetails.lineItems.references.entityData.refServiceLocation.address.zip',
            alias: 'Service Location Zip Code',
            shortName: 'Zip',
            searchableByDefault: false,
        },
        {
            field: 'invoiceDetails.lineItems.references.entityData.refServiceLocation.county',
            alias: 'Service Location County',
            shortName: 'County',
            searchableByDefault: false,
        },
    ],
    filterableAttributes: [
        {
            type: 'STRING',
            field: 'invoiceDetails.status_computed',
            useKeywordSubfield: false,
            alias: 'Invoice Status',
            shortName: 'Status',
            allowedOperators: 'ALL',
            allowsMultipleValues: true,
            options: {
                wayste: transport_types_1.Invoice.InvoiceStatuses.map((status) => ({
                    value: status,
                    label: transport_types_1.Invoice.InvoiceStatusLabels[status],
                })),
            },
        },
        {
            type: 'STRING',
            field: 'invoiceDetails.status',
            alias: 'Invoice Status (Legacy - Stale)',
            shortName: 'Status (Legacy)',
            allowedOperators: 'ALL',
            allowsMultipleValues: true,
            options: {
                wayste: transport_types_1.Invoice.InvoiceStatuses.map((status) => ({
                    value: status,
                    label: transport_types_1.Invoice.InvoiceStatusLabels[status],
                })),
            },
        },
        {
            type: 'STRING',
            field: 'invoiceDetails.lineItems.references.entityData.refStatus',
            alias: 'Service Status',
            shortName: 'Service Status',
            allowedOperators: 'ALL',
            allowsMultipleValues: true,
            options: {
                wayste: AllServiceStatuses.map((status) => ({
                    value: status,
                    label: AllServiceStatusLabels[status],
                })),
            },
        },
        {
            type: 'NUMBER',
            field: 'invoiceDetails.term',
            alias: 'Term',
            shortName: 'Term',
            allowedOperators: 'ALL',
            format: 'INTEGER',
        },
        {
            type: 'NUMBER',
            field: 'invoiceDetails.total',
            alias: 'Invoice Amount',
            shortName: 'Amount',
            allowedOperators: 'ALL',
            format: 'MONEY',
        },
        {
            type: 'NUMBER',
            field: 'invoiceDetails.remainingBalance',
            alias: 'Remaining Balance',
            shortName: 'Remaining Balance',
            allowedOperators: 'ALL',
            format: 'MONEY',
        },
        {
            type: 'TIMESTAMP',
            field: 'invoiceDetails.issueDate',
            alias: 'Issue Date',
            shortName: 'Issue Date',
            allowedOperators: 'ALL',
            format: 'ISO',
        },
        {
            type: 'TIMESTAMP',
            field: 'invoiceDetails.dueDate',
            alias: 'Due Date',
            shortName: 'Due Date',
            allowedOperators: 'ALL',
            format: 'ISO',
        },
        {
            type: 'TIMESTAMP',
            field: 'invoiceDetails.refunds.date',
            alias: 'Refund Date',
            shortName: 'Refund Date',
            allowedOperators: 'ALL',
            format: 'ISO',
        },
        {
            type: 'TIMESTAMP',
            field: 'invoiceDetails.payments.date',
            alias: 'Payment Date',
            shortName: 'Payment Date',
            allowedOperators: 'ALL',
            format: 'ISO',
        },
        {
            type: 'DATE',
            field: 'invoiceDetails.lineItems.references.entityData.startDate',
            alias: 'Start Date',
            shortName: 'Start Date',
            allowedOperators: 'ALL',
            format: 'YYYY-MM-DD',
        },
        {
            type: 'DATE',
            field: 'invoiceDetails.lineItems.references.entityData.endDate',
            alias: 'End Date',
            shortName: 'End Date',
            allowedOperators: 'ALL',
            format: 'YYYY-MM-DD',
        },
        ...meta_data_invoice_1.MetaDataFiltersInvoice,
    ],
    extraMappings: [
        {
            field: 'haulerID',
            elasticMapping: {
                type: 'text',
                fields: {
                    keyword: {
                        type: 'keyword',
                        ignore_above: 256,
                    },
                },
            },
        },
        invoice_status_computed_mapping_1.InvoiceStatusComputedMapping,
    ],
};
//# sourceMappingURL=wayste-receivable.js.map